// @flow
import type {Node} from 'react'
import React, {Suspense} from 'react'
import environment from 'environment'
import {RelayEnvironmentProvider} from 'react-relay'
import LoadingDots from 'components/ui/LoadingDots'
import PrintableGovernancePage, {type Props} from './PrintableGovernancePage'

function PrintableGovernance(props: Props): Node {
  return (
    <RelayEnvironmentProvider environment={environment}>
      <Suspense fallback={<LoadingDots />}>
        <PrintableGovernancePage {...props} />
      </Suspense>
    </RelayEnvironmentProvider>
  )
}

export default PrintableGovernance
